import { Component, OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AuthService } from './services/auth.service';
import { map } from 'rxjs/operators';
import { NotificationBellService } from './services/notification-bell.service';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { CommonModule } from '@angular/common';
import { MainContainerComponent } from './components/main-container/main-container.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'dapp';
  showNotifications = false;
  hasNotifications = false;
  hoveredIndex = -1;
  notifications: Array<{
    id?: string;
    type: string;
    title: string;
    body: string;
    read: boolean;
    timestamp?: any;
  }> = [];
  showBell = true;
  isMaintenancePage = false;
  maintenanceEnabled = false;

  @ViewChild('notificationDropdown') notificationDropdown!: ElementRef;

  constructor(
    private afs: AngularFirestore,
    private authService: AuthService,
    public bellService: NotificationBellService,
    private router: Router
  ) {
    this.bellService.showBell$.subscribe(val => this.showBell = val);
  }

  ngOnInit(): void {
    // Verificar si está activado el modo mantenimiento y forzar redirección una sola vez
    this.maintenanceEnabled = !!environment.maintenanceMode;
    if (this.maintenanceEnabled) {
      this.isMaintenancePage = true;
      this.showBell = false;
      if (this.router.url !== '/mantenimiento') {
        this.router.navigate(['/mantenimiento'], { replaceUrl: true });
      }
      return; // Evita suscripciones que puedan provocar bucles de navegación
    }

    // Detectar cambios de ruta para ocultar notificaciones en mantenimiento
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        const atMaintenance = event.urlAfterRedirects.startsWith('/mantenimiento');
        this.isMaintenancePage = atMaintenance || this.maintenanceEnabled;

        // Mientras mantenimiento esté activo, impedir navegar a cualquier otra ruta
        if (this.maintenanceEnabled && !atMaintenance) {
          this.router.navigate(['/mantenimiento'], { replaceUrl: true });
        }
      });

    this.authService.userAuth.subscribe((userAuth: any) => {
      const uid = userAuth?.uid;
      if (uid) {
        this.authService.saveUserdata(uid)
        this.afs.collection('user-notifications').doc(uid)
          .collection('notifications', ref => ref
            .where('read', '==', false)
            .orderBy('timestamp', 'desc')
          )
          .snapshotChanges()
          .pipe(
            map(actions => actions.map(a => {
              const data: any = a.payload.doc.data();
              const id = a.payload.doc.id;
              return { id, ...data };
            }))
          )
          .subscribe((notifs: any[]) => {
            this.notifications = notifs;
            this.hasNotifications = this.notifications.length > 0;
          });
      } else {
        this.notifications = [];
        this.hasNotifications = false;
      }
    });
  }

  markAsRead(index: number) {
    const notif = this.notifications[index];
    if (notif && notif.id) {
      const userAuth = this.authService.userAuth.getValue();
      const uid = userAuth?.uid;
      this.afs.collection('user-notifications').doc(uid)
        .collection('notifications')
        .doc(notif.id)
        .delete();
    }
  }

  markAllAsRead(event: any) {
    const userAuth = this.authService.userAuth.getValue();
    const uid = userAuth?.uid;
    this.notifications.forEach(n => {
      if (n.id) {
        this.afs.collection('user-notifications').doc(uid)
          .collection('notifications')
          .doc(n.id)
          .delete();
      }
    });
  }

@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent) {
  const clickedInsideDropdown = this.notificationDropdown?.nativeElement.contains(event.target);
  const clickedOnBell = (event.target as HTMLElement).closest('.notification-bell');

  if (!clickedInsideDropdown && !clickedOnBell) {
    this.showNotifications = false;
  }
}

}